import React from 'react';

import { Button, Icon } from '@digital/ui';
import { Tooltip } from 'antd';
import api from '@app/api/api';


interface IUploadProps {
  idDoComponente: string;
  id: string;
  enderecoApi: string;
  nomeIdFormulario: string;
  iconName: React.ComponentProps<typeof Icon>['name'];
  hasFile: boolean;
  label?: string | undefined;
  buttonClass?: string | undefined;
  retorno: (data: any) => void;
  disabled?: boolean;
  type?: "default" | "primary" | "ghost" | "dashed" | "danger" | "link";
  tooltip?: string;
}

export const UploadComponent = (
  { id,
    enderecoApi,
    retorno,
    idDoComponente,
    nomeIdFormulario,
    iconName,
    hasFile,
    label,
    buttonClass,
    disabled,
    type = 'link',
    tooltip = "Adicionar Arquivo"
  }: IUploadProps) => {

  const teveMudanca = () => {
    const elemento = document.getElementById(`mrn-input-upload-${idDoComponente}`) as any;
    if (elemento) {
      const curFiles = elemento.files;

      const form = new FormData();
      form.append('File', curFiles[0]);
      form.append(nomeIdFormulario, id);
      api
        .post(enderecoApi, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(data => {
          elemento.value = '';
          retorno(data);
        });
    }
  };

  const triggerMudanca = () => {
    const elemento = document.getElementById(`mrn-input-upload-${idDoComponente}`);
    if (elemento) {
      elemento.click();
    }
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <input
          id={`mrn-input-upload-${idDoComponente}`}
          type="file"
          onChange={teveMudanca}
          className="custom-input-type-file"
          style={{ cursor: 'pointer !important', display: 'none' }}
        />
        <Button
          id={`mrn-button-upload-${idDoComponente}`}
          icon={iconName}
          onClick={() => triggerMudanca()}
          className={(hasFile ? 'has-comments ' : '') + buttonClass}
          title={label}
          disabled={disabled}
          type={type}
        />
      </Tooltip>
    </>
  );
};
